export default __webpack_public_path__ + "img/9294fa280547fb4aff8c819bebed9ee5.svg";